import React, { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from "@/components/ui/button";
import { BellIcon } from '@heroicons/react/24/outline';
import { apiFetch } from '@/utils/api';
import { useI18n } from '../hooks/useI18n';

interface PendingTimeOffRequestsButtonProps {
    className?: string;
}

export function PendingTimeOffRequestsButton({ className }: PendingTimeOffRequestsButtonProps) {
    const { t } = useI18n();
    const navigate = useNavigate();
    const [pendingCount, setPendingCount] = useState<number>(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadPendingCount();
    }, []);

    const loadPendingCount = async () => {
        try {
            setLoading(true);
            const response = await apiFetch('/api/timesheet/time-off-requests?status=pending&per_page=1');
            
            if (!response.ok) {
                console.error('Failed to load pending requests count');
                return;
            }
            
            const data = await response.json();
            setPendingCount(data.total || 0);
        } catch (err) {
            console.error('Failed to load pending requests count:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleClick = () => {
        navigate({ to: '/people/timeoff/requests' });
    };

    if (loading || pendingCount === 0) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleClick}
            className={className}
        >
            <BellIcon className="h-4 w-4 mr-2" />
            {pendingCount} {pendingCount !== 1 ? t('timeOff.pendingRequests', 'common') : t('timeOff.pendingRequest', 'common')}
        </Button>
    );
}

